import { useEffect, useState } from 'react';
import {
  Chat, Channel, MessageList,
  MessageInput, Window, Thread
} from 'stream-chat-react';
import { StreamChat } from 'stream-chat';
import Lottie from 'lottie-react';
import 'stream-chat-react/dist/css/v2/index.css';
import './App.css';
import logo from './logo.png';

const LOTTIE_URL =
  'https://storage.googleapis.com/flutterflow-io-6f20.appspot.com/projects/p-a-connect-na7zyx/assets/dpsdeg4kec1a/loading-dots-blue-smooth.json';

const CustomHeader = ({ channel, userId }) => {
  const members = Object.values(channel?.state?.members || {});
  const other = members.find(m => m.user_id !== userId);
  const name = other?.user?.name || channel?.data?.name || 'Chat';
  const image = other?.user?.image || null;

  return (
    <div style={{
      height: 64, background: '#fff', borderBottom: '1px solid #E2E8F0',
      display: 'flex', alignItems: 'center', padding: '0 16px', gap: 12, flexShrink: 0
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: '50%',
        background: '#E6F7FD', display: 'flex', alignItems: 'center',
        justifyContent: 'center', overflow: 'hidden', flexShrink: 0
      }}>
        {image
          ? <img src={image} alt={name}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={e => {
                e.target.style.display = 'none';
                e.target.parentNode.innerText = name.charAt(0).toUpperCase();
              }}
            />
          : <span style={{ fontSize: 16, fontWeight: 600, color: '#009BD2' }}>
              {name.charAt(0).toUpperCase()}
            </span>
        }
      </div>
      <div>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#0F172A' }}>{name}</div>
        <div style={{ fontSize: 12, color: '#64748B' }}>
          {other?.user?.online ? '🟢 Online' : 'Offline'}
        </div>
      </div>
    </div>
  );
};

const Loader = ({ label }) => {
  const [anim, setAnim] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(LOTTIE_URL).then(r => r.json()).then(j => { if (alive) setAnim(j); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100dvh', flexDirection: 'column', gap: 8
    }}>
      {anim
        ? <Lottie animationData={anim} loop style={{ width: 120, height: 60 }} />
        : <div style={{ width: 32, height: 32, border: '3px solid #E2E8F0', borderTopColor: '#009BD2', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />}
      <p style={{ fontSize: 14, color: '#64748B' }}>{label}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default function App() {
  const p = new URLSearchParams(window.location.search);
  const apiKey    = p.get('apiKey');
  const token     = p.get('token');
  const channelId = p.get('channelId');
  const userId    = p.get('userId');
  const userName  = p.get('userName') || 'User';
  const userImage = p.get('userImage') || '';

  const [client, setClient] = useState(null);
  const [channel, setChannel] = useState(null);
  const [error, setError]   = useState(null);

  useEffect(() => {
    if (!apiKey || !token || !channelId || !userId) {
      setError('Missing parameters.'); return;
    }
    const sc = StreamChat.getInstance(apiKey);
    sc.connectUser({ id: userId, name: userName, image: userImage }, token)
      .then(() => {
        const ch = sc.channel('messaging', channelId);
        return ch.watch().then(() => { setClient(sc); setChannel(ch); });
      })
      .catch(e => setError(e.message));
    return () => { sc.disconnectUser(); };
  }, []);

  if (error) return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100dvh', gap:12, padding:32, textAlign:'center' }}>
      <div style={{ fontSize:40 }}>⚠️</div>
      <p style={{ fontSize:14, color:'#64748B' }}>{error}</p>
    </div>
  );

  if (!client || !channel) return <Loader label="Connecting…" />;

  return (
    <div style={{ height:'100dvh', display:'flex', flexDirection:'column' }}>
      <Chat client={client} theme="str-chat__theme-light">
        <Channel channel={channel}>
          <Window>
            <CustomHeader channel={channel} userId={userId} />
            <MessageList />
            <MessageInput focus />
          </Window>
          <Thread />
        </Channel>
      </Chat>
    </div>
  );
}